'use client';
import { useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
    const { currentPost, postsBasePath } = useLoadPostBySlug("choiseul-africa");

    return (
        <article>
            {currentPost && (
                <div style={{ backgroundImage: `url(${currentPost.image})` }} className={"h-[400px] w-full bg-cover bg-center relative"}
                >
                    <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}
                    >
                        <SectionPage sectionType={"2xl"}
                        >
                            <h1 className={"text-white text-4xl font-exo"}
                            >{currentPost.title}</h1>
                        </SectionPage>
                    </div>
                </div>
            )}

            <SectionPage sectionType={"xl"} className={"my-12"}>
                <div className="markdown-content text-gray-800">
                    <h1 className="text-3xl font-bold font-exo text-rose mt-8 mb-4">Malékah MOURAD-CONDE : Le tourisme doit être érigé en axe prioritaire et stratégique afin qu'il soit un instrument de lutte contre la pauvreté en milieu rural et un levier de création d'emplois pour les jeunes et les femmes.</h1>

                    <p className="my-4 text-normal leading-relaxed">
                        Le Directeur Général de Côte d'Ivoire Tourisme a pris part ce Jeudi 14 Septembre à Abidjan à un séminaire organisé par l'Institut CHOISEUL AFRICA sur les chaînes de valeur durables en Afrique pour le secteur du tourisme, en présence de plus de 200 dirigeants économiques de haut niveau venus de la sous-région, d'Afrique et d'Europe.
                    </p>

                    <p className="my-4 text-normal leading-relaxed">
                        A cet effet, elle a présenté les 8 axes stratégiques à adresser afin de co – construire une destination touristique durable, responsable et équitable. Il s'agit d'une nouvelle gouvernance de l'Office, une plus grande collaboration avec les socio professionnels, une stratégie de promotion et de communication audacieuse, une nouvelle politique d'accueil, la digitalisation de l'économie touristique, la démocratisation du tourisme, le développement du capital humain et l'identification de nouvelles sources de financement. Ce projet prend en compte toutes les chaines de valeur de l'industrie touristique ainsi que les territoires.
                    </p>

                    <p className="my-4 text-normal leading-relaxed">
                        Dans le cadre de leur mise en œuvre, des initiatives sont en cours de déploiement notamment à travers des partenariats avec le Haut Conseil du Patronat des Entreprises de Transport Routier, les opérateurs hôteliers de la ville de Jacqueville et l'Université de San Pedro.
                    </p>

                    <p className="my-4 text-normal leading-relaxed">
                        Malékah MOURAD-CONDE s'appuie entre autres sur le modèle du développement touristique de la ville de Yamoussoukro auquel elle a contribué en synergie avec tous les acteurs intervenant dans la chaîne de valeur ; des actions qui ont fait triplé le chiffre d'affaires des hôtels alors qu'elle était à la tête de la SODERTOUR – LACS, Société De Développement Touristique de la Région des Lacs entre 2011 et 2021.
                    </p>

                    <p className="my-4 text-normal leading-relaxed">
                        Ont également pris part à ce panel, Charles KIÉ, Président Directeur Général du Groupe Genesis, Co-fondateur et Directeur Général de New African Capital Partners (NACP) et SBNA, Alain KOUADIO, Président – Fondateur du Groupe KAYDAN, Leticia N'CHO TRAORÉ, Directrice Générale du Groupe Addict et Lolo DIBY, Président de la Fédération Nationale de l'Industrie Hôtelière de Côte d'Ivoire (FNIH-CI). De la finance à l'agrobusiness en passant par le tourisme, chacun de ces secteurs a été passé au scanner des panélistes afin qu'émergent des feuilles de route stratégiques en faveur de véritables chaînes de valeur durables et résilientes sur le continent africain.
                    </p>

                    <p className="my-4 text-normal leading-relaxed">
                        (Illustration video titrée ok-DG CIT-CHOISEUL Africa)
                    </p>
                </div>

                {currentPost && <SimilarPosts currentSlug={currentPost.slug} />}

            </SectionPage>
        </article>
    );
}
